<template>
	<el-dialog :append-to-body="true" :visible="visible" width="900px" custom-class="login-dialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
		<!-- 关闭按钮 -->
		<div class="dialog-close" @click="handleClose">
			<i class="el-icon-close"></i>
		</div>
		<!-- 主体内容 -->
		<div class="login-main">
			<!-- 左边：微信登录 -->
			<div class="login-left">
				<!-- <div class="login-info-box">
					<img src="@/assets/images/20260303-132952.png" alt="" class="net-logo" />
					<h3 class="section-title">登录</h3>
					<div class="login-tips">
						<p>欢迎登录特规通平台</p>
					</div>
				</div> -->
				<div class="wechat-login-box">
					<img src="@/assets/images/logo_person_.png" alt="" class="net-logo" />
					<h3 class="section-title">登录</h3>
					<div class="qrcode-container">
						<div v-if="!wechatQrCodeUrl" class="qrcode-loading">
							<i class="el-icon-loading loading-icon"></i>
							<p>正在加载二维码...</p>
						</div>
						<div class="qrcode-content" v-else>
							<div class="qrcode-wrapper" id="qrcode-wrapper">
								<iframe :src="wechatQrCodeUrl" frameborder="0" class="qrcode-img"></iframe>
								<p class="qrcode-tips">请使用微信扫一扫登录</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 右边：登录表单 -->
			<div class="login-right">
				<div class="register-link"><span>没有账号？</span><el-link type="primary" :underline="false" @click="register">前往注册></el-link></div>
				<div class="form-container">
					<!-- 登录方式切换 -->
					<div class="login-type-tabs flexBetween">
						<ul class="type-tabs">
							<li :class="{ active: loginType === 'password' }" @click="onTabClick('password')">
								<!-- <i class="el-icon-lock"></i> -->
								密码登录
							</li>
							<li :class="{ active: loginType === 'phone' }" @click="onTabClick('phone')">
								<!-- <i class="el-icon-mobile-phone"></i> -->
								验证码登录
							</li>
						</ul>
					</div>

					<!-- 登录表单 -->
					<el-form ref="loginForm" :model="formData" :rules="rules" class="login-form" label-width="0">
						<!-- 手机号输入 -->
						<el-form-item prop="phone" v-if="loginType === 'phone'">
							<el-input v-model.trim="formData.phone" placeholder="请输入手机号码" size="large" prefix-icon="el-icon-mobile-phone" maxlength="11" />
						</el-form-item>

						<!-- 账号输入 -->
						<el-form-item prop="account" v-if="loginType === 'password'">
							<el-input v-model.trim="formData.account" placeholder="请输入手机号码" size="large" prefix-icon="el-icon-user" />
						</el-form-item>

						<!-- 验证码输入 -->
						<el-form-item prop="verifyCode" v-if="loginType === 'phone'">
							<div class="verify-code-input">
								<el-input v-model.trim="formData.verifyCode" placeholder="请输入短信验证码" size="large" prefix-icon="el-icon-message" maxlength="6" />
								<el-button :disabled="waitNum > 0" type="primary" size="large" @click="toSendMsg" class="send-code-btn">
									{{ waitNum > 0 ? waitNum + '秒后重发' : '获取验证码' }}
								</el-button>
							</div>
						</el-form-item>

						<!-- 密码输入 -->
						<el-form-item prop="password" v-if="loginType === 'password'">
							<el-input v-model.trim="formData.password" type="password" placeholder="请输入密码" size="large" prefix-icon="el-icon-lock" show-password />
						</el-form-item>

						<!-- 协议同意 -->
						<el-form-item class="agreement-item">
							<el-checkbox v-model="formData.agreeFlag">
								已阅读并同意
								<div class="agreement-text">
									<el-link type="primary" :underline="false" @click="goto(1, '用户协议')">用户协议</el-link>、
									<el-link style="margin-left: -2px" type="primary" :underline="false" @click="goto(2, '隐私协议')">隐私协议</el-link>、
									<el-link style="margin-left: -2px" type="primary" :underline="false" @click="goto(3, '图书销售协议')">图书销售协议</el-link>
								</div>
							</el-checkbox>
						</el-form-item>

						<!-- 登录按钮 -->
						<el-form-item>
							<el-button :loading="loadingLoginBtn" type="primary" size="large" class="login-btn" @click="handleLogin">
								{{ loginType === 'password' ? '立即登录' : '立即登录' }}
							</el-button>
						</el-form-item>
					</el-form>

					<!-- 其他登录方式 -->
					<div class="other-login-ways">
						<!-- <el-divider content-position="center">其他登录方式</el-divider>
						<div class="login-icons">
							<el-tooltip content="微信登录" placement="top">
								<div class="login-icon wechat-icon" @click="switchToWechat">
									<i class="el-icon-chat-dot-round"></i>
								</div>
							</el-tooltip>
						</div>-->
						<!-- <p style="font-size: 14px">注：如果您还没注册过特规通平台，则登录即代表了注册</p> -->
					</div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import { mapActions } from 'vuex';
	import mtils from 'mtils';
	import EFormat from '@/utils/EFormat';
	import TMessage from '@/utils/TMessage';
	import { getMemberSms, getMemberLoginUrl } from '@/api/user/login';
	import CUser from '@/utils/User';
	import { SITE_URL, LOGIN_TYPE_PERSONAL } from '@/data/siteConfig';
	import { goLoginRedirect } from '@/utils/complianceEntry';

	// Element Plus 图标
	// import {
	//     Phone,
	//     User,
	//     Message,
	//     Lock,
	//     ChatDotRound,
	//     Loading
	// } from '@element-plus/icons-vue';

	export default {
		name: 'Login',
		// components: {
		//     Phone,
		//     User,
		//     Message,
		//     Lock,
		//     ChatDotRound,
		//     Loading
		// },
		props: {
			// visible: {
			// 	type: Boolean,
			// 	default: false
			// }
		},
		data() {
			// 手机号验证规则
			const validatePhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号码'));
				}
				if (!mtils.validation.isMobile(value)) {
					return callback(new Error('手机号码格式不正确'));
				}
				callback();
			};

			// 验证码验证规则
			const validateCode = (rule, value, callback) => {
				const patternCode = /^[0-9]{6}$/;
				if (!value) {
					return callback(new Error('请输入短信验证码'));
				}
				if (!patternCode.test(value)) {
					return callback(new Error('验证码格式不正确'));
				}
				callback();
			};

			return {
				mainHeight: window.innerHeight,
				loginType: 'password', // phone, password
				wechatQrCodeUrl: null,
				loadingLoginBtn: false,
				waitNum: 0,
				wtimer: null,

				formData: {
					phone: '',
					account: '',
					password: '',
					verifyCode: '',
					verifyKey: '',
					agreeFlag: false
				},

				rules: {
					phone: [{ validator: validatePhone, trigger: 'blur' }],
					account: [{ required: true, message: '账号不可为空', trigger: 'blur' }],
					password: [{ required: true, message: '密码不可为空', trigger: 'blur' }],
					verifyCode: [{ validator: validateCode, trigger: 'blur' }]
				}
			};
		},

		computed: {
			visible() {
				let val = this.$store.getters['Settings/sLoginShowPersonal'];
				if (val) {
					this.$nextTick(() => {
						this.initWechatLogin();
						window.addEventListener('message', this.handleMessage);
						this.$refs.loginForm.resetFields();
					});
				} else {
					this.stopWait();
					window.removeEventListener('message', this.handleMessage);
				}
				return val;
			}
		},

		mounted() {
			// this.initWechatLogin();
			window.addEventListener('resize', this.handleResize);
			// window.addEventListener('message', this.handleMessage);
		},

		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
			// window.removeEventListener('message', this.handleMessage);
			this.stopWait();
		},

		methods: {
			async handleMessage(event) {
				console.log('收到消息', event.data.type);
				// 验证消息格式
				if (!event.data || typeof event.data !== 'object') {
					return;
				}

				// 处理微信登录成功消息（个人版回调页已直接跳转子域名，此分支为兜底）
				if (event.data.type === 'wechatLoginSuccess') {
					TMessage.success('登录成功');
					this.setLoginShowPersonal(false);
				
					// 兜底：同步 token 到 store
					const token = localStorage.getItem('token');
					if (token) {
						this.$store.commit('User/setToken', token);
					}
					CUser.setLoginType(LOGIN_TYPE_PERSONAL);
					// 直接跳转个人版，手机号校验由个人版路由守卫处理（智能工具打标时由总入口判定权限并直跳合规系统）
					await goLoginRedirect(SITE_URL.PERSON, CUser.getToken());
					return;
				}

				// 处理微信登录失败消息
				if (event.data.type === 'wechatLoginFail') {
					TMessage.error(event.data.msg);
					this.$nextTick(() => {
						this.initWechatLogin();
					});
					return;
				}

				// 处理微信绑定成功消息
				if (event.data.type === 'wechatBindSuccess') {
					console.log('收到微信绑定成功消息');
					TMessage.success('微信绑定成功');
					this.setLoginShowPersonal(false);
					return;
				}

				// 处理微信初始化消息（登录失败时）
				if (event.data.type === 'wechatUrlInit') {
					console.log('收到微信初始化消息，重新加载二维码');
					this.$nextTick(() => {
						this.initWechatLogin();
					});
					return;
				}
			},

			// 重置微信iframe
			resetWechatIframe() {
				this.wechatQrCodeUrl = null;
				this.$nextTick(() => {
					this.initWechatLogin();
				});
			},

			register() {
				this.setLoginShowPersonal(false);
				this.setRegisterShow(true);
				this.$emit('register');
			},

			...mapActions('User', ['login', 'getUserInfo']),
			...mapActions('Settings', ['setLoginShowPersonal', 'setRegisterShow']),

			// 初始化微信登录
			async initWechatLogin() {
				try {
					const res = await getMemberLoginUrl('pLogin_' + Math.random().toString());
					if (res && res.data) {
						this.wechatQrCodeUrl = res.data;
					}
				} catch (error) {
					console.error('初始化微信登录失败:', error);
					TMessage.error('微信登录初始化失败');
				}
			},

			// 发送验证码
			toSendMsg() {
				this.$refs.loginForm.validateField('phone', async errorMessage => {
					if (!errorMessage) {
						try {
							this.startWait();
							const res = await getMemberSms(this.formData.phone);
							if (res.code === 200) {
								this.formData.verifyKey = res.data;
								TMessage.success('验证码已发送');
							} else {
								this.stopWait();
								TMessage.warning(res.msg || '短信发送失败');
							}
						} catch (error) {
							this.stopWait();
							TMessage.error('发送验证码失败');
						}
					}
				});
			},

			// 开始倒计时
			startWait() {
				this.waitNum = 60;
				if (this.wtimer) {
					this.stopWait();
				}
				this.wtimer = setInterval(() => {
					this.waitNum--;
					if (this.waitNum <= 0) {
						this.stopWait();
					}
				}, 1000);
			},

			// 停止倒计时
			stopWait() {
				clearInterval(this.wtimer);
				this.wtimer = null;
				this.waitNum = 0;
			},

			// 处理登录
			handleLogin() {
				this.$refs.loginForm.validate(async valid => {
					if (valid) {
						if (!this.formData.agreeFlag) {
							TMessage.warning('请阅读并同意注册协议');
							return;
						}

						this.loadingLoginBtn = true;
						let loginParams = {};

						if (this.loginType === 'password') {
							loginParams = {
								itype: 2,
								phone: this.formData.account,
								password: EFormat.base64encode(this.formData.password)
							};
						} else if (this.loginType === 'phone') {
							loginParams = {
								itype: 1,
								phone: this.formData.phone,
								verifyCode: this.formData.verifyCode,
								verifyKey: this.formData.verifyKey
							};
						}

						this.$store
							.dispatch('User/login', loginParams)
							.then(async () => {
								TMessage.success('登录成功');
								// 标记登录类型为个人版
								CUser.setLoginType(LOGIN_TYPE_PERSONAL);
								// 跳转到个人版子域名（开发环境通过 URL 参数传递 token）
								await goLoginRedirect(SITE_URL.PERSON, CUser.getToken());
							})
							.catch(error => {
								TMessage.error(error.msg || '登录失败');
							})
							.finally(() => {
								this.loadingLoginBtn = false;
							});
					}
				});
			},

			// 登录成功后执行
			onSuccess() {
				this.setLoginShowPersonal(false);
				let act = this.$store.getters['Settings/sLoginSuccessAct'];
				// 登录后执行
				switch (act) {
					case 'openAI':
						this.$router.push({
							path: '/index/Ai'
						});
						break;
					case 'onAddToCart':
						this.onAddToCart();
						break;
					case 'openBookBox':
						this.openBookBox();
						break;
					case 'openPDF':
						this.openPDF();
						break;
					case 'openDoc':
						this.openDoc();
						break;
					case 'download':
						this.download();
						break;
					case 'onBuy':
						this.onBuy();
						break;
				}
			},

			onTabClick(tab) {
				this.loginType = tab;
				this.loadingLoginBtn = false;
				this.$nextTick(() => {
					this.$refs.loginForm.resetFields();
				});
			},

			// 切换到微信登录
			switchToWechat() {
				this.initWechatLogin();
			},

			// 跳转到协议页面
			goto(id, title) {
				const query = {
					group: '关于我们',
					id,
					type: 'content',
					title
				};
				const routeData = this.$router.resolve({
					path: '/info',
					query
				});
				window.open(routeData.href, '_blank');
			},

			// 关闭弹窗
			handleClose() {
				this.setLoginShowPersonal(false);
			},

			// 跳转到首页
			toHome() {
				this.$router.push('/');
			},

			// 处理窗口大小变化
			handleResize() {
				this.mainHeight = window.innerHeight;
			}
		}
	};
</script>

<style lang="less" scoped>
	// 弹窗样式
	:deep(.login-dialog) {
		.el-dialog {
			border-radius: 12px;
			overflow: hidden;
			box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

			.el-dialog__header {
				display: none;
			}

			.el-dialog__body {
				padding: 0;
			}
		}
	}

	.login-wrapper {
		min-height: 100vh;
		background-size: cover;
		background-image: url('@/assets/images/pointwrap-bg.jpg');
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
	}

	.login-container {
		width: 100%;
		max-width: 920px;
	}

	.login-header {
		position: absolute;
		left: 20px;
		top: 20px;

		.logo {
			cursor: pointer;

			.logo-img {
				height: 36px;
				margin-right: 12px;
			}

			.logo-text {
				font-size: 28px;
				font-weight: 600;
				color: #303133;
				letter-spacing: 1px;
			}
		}

		.header-tips {
			font-size: 14px;
			color: #909399;
			line-height: 1.5;
		}
	}

	.login-title {
		color: #4a4f57;
		margin-bottom: 40px;
		font-size: 42px;
		font-weight: 600;
		line-height: 56px;
		letter-spacing: normal;
		text-align: center;
	}

	.login-main {
		display: flex;
		min-height: 500px;
		background: white;
	}

	.login-left {
		flex: 1;
		padding: 40px 40px 40px 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		.net-logo {
			width: 180px;
			position: absolute;
			left: 28px;
			top: -30px;
		}
	}

	.login-info-box {
		text-align: center;
		background: #f5f7fa;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;

		.section-title {
			font-size: 30px;
			color: #303133;
			margin-bottom: 30px;
			margin-top: 0;
			font-weight: 600;
		}

		.login-tips {
			color: #606266;
			font-size: 14px;
			line-height: 1.8;

			p {
				margin: 8px 0;
			}
		}
	}

	.wechat-login-box {
		width: 392px;
		height: 445px;
		text-align: center;
		background: #fff;
		border-radius: 8px;
		border: 1px solid #e4e7ed;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		.section-title {
			font-size: 30px;
			color: #303133;
			margin-bottom: 30px;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: center;

			i {
				margin-right: 8px;
				color: #67c23a;
				font-size: 22px;
			}
		}

		.qrcode-container {
			margin-bottom: 25px;

			.qrcode-loading {
				padding: 40px;
				color: #909399;

				.loading-icon {
					font-size: 40px;
					margin-bottom: 15px;
					color: #409eff;
					animation: spin 1s linear infinite;
				}

				p {
					font-size: 14px;
					margin: 0;
				}

				@keyframes spin {
					0% {
						transform: rotate(0deg);
					}
					100% {
						transform: rotate(360deg);
					}
				}
			}

			.qrcode-content {
				.qrcode-wrapper {
					padding: 15px;
					padding-top: 40px;

					display: inline-block;
				}

				.qrcode-img {
					// width: 180px;
					// height: 180px;
					width: 360px;
					height: 200px;
					display: block;
				}

				.qrcode-tips {
					margin-top: 20px;
					color: #606266;
					font-size: 14px;
					line-height: 1.5;
				}
			}
		}

		.wechat-tips {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #67c23a;
			font-size: 14px;
			padding: 12px 20px;
			background: rgba(103, 194, 58, 0.1);
			border-radius: 20px;

			i {
				margin-right: 8px;
				font-size: 16px;
			}
		}
	}

	.login-right {
		flex: 1;
		padding: 40px;
		background: #fff;
		position: relative;
		overflow: hidden;
	}

	.register-link {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 20px;
		font-size: 14px;
		color: #94a3b8;

		span {
			line-height: 1.5;
		}
	}

	.form-container {
		max-width: 380px;
		margin: 0 auto;
		position: relative;
	}

	.dialog-close {
		position: absolute;
		top: 15px;
		right: 15px;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #f5f7fa;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;
		z-index: 1000;

		&:hover {
			background: #e4e7ed;
			color: #409eff;
		}

		i {
			font-size: 16px;
			font-weight: 600;
		}
	}

	.login-type-tabs {
		margin-bottom: 35px;
		text-align: center;

		.type-tabs {
			display: flex;
			list-style: none;
			padding: 0;
			margin: 0;
			border-bottom: 1px solid #e4e7ed;

			li {
				padding: 12px;
				font-size: 16px;
				color: #303133;
				cursor: pointer;
				transition: all 0.3s ease;
				position: relative;
				border-bottom: 3px solid #fff;
				margin-bottom: -1px;
				font-weight: 600;

				i {
					margin-right: 6px;
					font-size: 16px;
				}

				&:hover {
					color: #409eff;
				}

				&.active {
					color: #409eff;
					border-bottom-color: #409eff;
					font-weight: 600;

					i {
						color: #409eff;
					}
				}
			}
		}
	}

	.login-form {
		.el-form-item {
			margin-bottom: 28px;

			.el-form-item__content {
				line-height: normal;
			}
		}

		.verify-code-input {
			display: flex;
			gap: 12px;

			.el-input {
				flex: 1;
			}

			.send-code-btn {
				white-space: nowrap;
				min-width: 110px;
				font-size: 14px;
			}
		}

		.agreement-item {
			margin-bottom: 25px;

			:deep(.el-checkbox__label) {
				font-size: 13px;
				color: #606266;
				line-height: 1.5;
				position: relative;
			}

			.el-link {
				font-size: 13px;
			}

			.agreement-text {
				display: inline-block;
				line-height: 1.5;
				position: absolute;
				top: -2px;
			}
		}

		.login-btn {
			width: 100%;
			height: 44px;
			font-size: 16px;
			border-radius: 6px;
			font-weight: 500;
			letter-spacing: 1px;
		}
	}

	.other-login-ways {
		margin-top: 35px;

		.el-divider__text {
			background: #fff;
			padding: 0 15px;
			font-size: 13px;
			color: #909399;
		}

		.login-icons {
			display: flex;
			justify-content: center;
			gap: 25px;
			margin-top: 20px;

			.login-icon {
				width: 44px;
				height: 44px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.3s ease;
				border: 1px solid #e4e7ed;
				background: #f5f7fa;

				i {
					font-size: 20px;
				}

				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				}

				&.wechat-icon {
					color: #67c23a;
					border-color: #67c23a;

					&:hover {
						background: #67c23a;
						color: white;
					}
				}
			}
		}
	}

	// 移除底部信息样式，因为弹窗不需要底部信息

	// 响应式设计
	@media (max-width: 768px) {
		.login-wrapper {
			padding: 10px;
		}

		.login-main {
			flex-direction: column;
			min-height: auto;
		}

		.login-left {
			border-right: none;
			border-bottom: 1px solid #e4e7ed;
			padding: 30px 20px;
		}

		.login-right {
			padding: 30px 20px;
		}

		.login-header {
			padding: 25px 20px 20px;

			.logo {
				.logo-text {
					font-size: 24px;
				}
			}
		}

		.form-container {
			max-width: 100%;
		}

		.wechat-login-box {
			.qrcode-content {
				.qrcode-wrapper {
					padding: 10px;
				}

				.qrcode-img {
					width: 150px;
					height: 150px;
				}
			}
		}
	}

	// Element UI 标准字体和颜色
	:deep(.el-input__inner) {
		border-radius: 6px;
		font-size: 14px;
	}

	:deep(.el-button) {
		border-radius: 6px;
	}

	:deep(.el-radio-button__inner) {
		border-radius: 6px;
	}
</style>
